import { render, staticRenderFns } from "./Owner.vue?vue&type=template&id=bc63a20a&scoped=true&"
import script from "./Owner.vue?vue&type=script&lang=ts&"
export * from "./Owner.vue?vue&type=script&lang=ts&"
import style0 from "./Owner.vue?vue&type=style&index=0&id=bc63a20a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc63a20a",
  null
  
)

export default component.exports